import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import {UserGeneralInfo} from "./userTabs/UserGeneralInfo";
import {UserInventory} from "./userTabs/UserInventory";
import {UserBalanceHistory} from "./userTabs/UserBalanceHistory";
import BidsTable from "../bids/BidsTable";
import {OrdersGeneral} from "../orders/OrdersGeneral";
import {UserOperations} from "./userTabs/UserOperations";
import {UserPenaltyInfo} from "./userTabs/UserPenaltyInfo";
import {UserSessions} from "./userTabs/UserSessions";
import {UserBlocksTab} from "./userTabs/UserBlocksTab";
import {UserAccessBlacklistTab} from "./userTabs/UserAccessBlacklistTab";
import {NavigationTabs} from '../../components/tab/NavigationTabs';

export function User() {
    const {id} = useParams();
    const navigate = useNavigate();
    const userId = BigInt(id || -1);
    const [blacklistTick, setBlacklistTick] = React.useState(0);
    const notifyBlacklistChanged = React.useCallback(() => setBlacklistTick((t) => t + 1), []);

    return (
        <Box sx={{display: 'flex', minHeight: '100dvh'}}>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: {xs: 2, md: 6},
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: {xs: 2, sm: 2, md: 3},
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: 1,
                        gap: 1,
                        flexDirection: {xs: 'column', sm: 'row'},
                        alignItems: {xs: 'start', sm: 'center'},
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Breadcrumbs
                        size="sm"
                        aria-label="breadcrumbs"
                        separator={<ChevronRightRoundedIcon/>}
                        sx={{pl: 0}}
                    >
                        <HomeRoundedIcon/>
                        <Link
                            underline="hover"
                            color="neutral"
                            sx={{fontSize: 12, fontWeight: 500}}
                            onClick={() => navigate('/app/users')}
                        >
                            Пользователи
                        </Link>
                        <Typography color="primary" sx={{fontWeight: 500, fontSize: 12}}>
                            {id}
                        </Typography>
                    </Breadcrumbs>
                </Box>
                <Typography level="h2" component="h1">
                    Пользователь
                </Typography>
                <NavigationTabs tabs={[
                    {
                        tabSlug: 'general',
                        tabTitle: 'Общая информация',
                        tabContent: <UserGeneralInfo onAccessBlacklistChanged={notifyBlacklistChanged} />
                    },
                    {
                        tabSlug: 'inventory',
                        tabTitle: 'Инвентарь',
                        tabContent: <UserInventory/>
                    },
                    {
                        tabSlug: 'balance',
                        tabTitle: 'График баланса',
                        tabContent: <UserBalanceHistory/>
                    },
                    {
                        tabSlug: 'orders',
                        tabTitle: 'Заказы',
                        tabContent: <OrdersGeneral userId={BigInt(id || -1)} />
                    },
                    {
                        tabSlug: 'bids',
                        tabTitle: 'Заявки',
                        tabContent: <BidsTable userId={BigInt(id || -1)} />
                    },
                    {
                        tabSlug: 'operations',
                        tabTitle: 'Операции',
                        tabContent: <UserOperations/>
                    },
                    {
                        tabSlug: 'blocks',
                        tabTitle: 'Блокировки',
                        tabContent: <UserBlocksTab userId={BigInt(id || -1)} />
                    },
                    {
                        tabSlug: 'bans',
                        tabTitle: 'Штрафные баллы',
                        tabContent: <UserPenaltyInfo/>
                    },
                    {
                        tabSlug: 'sessions',
                        tabTitle: 'Сессии',
                        tabContent: <UserSessions/>
                    },
                    {
                        tabSlug: 'access-blacklist',
                        tabTitle: 'Черный список',
                        tabContent: <UserAccessBlacklistTab userId={userId} refreshKey={blacklistTick} onChanged={notifyBlacklistChanged} />
                    },
                ]} />
            </Box>
        </Box>

    );
}
